module.exports = {
  text: {
    key: 'text',
    label: 'Text',
  },
  image: {
    key: 'image',
    label: 'Image',
  },
  conferenceRoomCreate: {
    key: 'conferenceRoomCreate',
    label: 'Conference Room Create',
  },
  conferenceRoomJoin: {
    key: 'conferenceRoomJoin',
    label: 'Conference Room Join',
  },
  conferenceRoomLeave: {
    key: 'conferenceRoomLeave',
    label: 'Conference Room Leave',
  },
  conferenceRoomEnd: {
    key: 'conferenceRoomEnd',
    label: 'Conference Room End',
  },
  conferenceRoomMessage: {
    key: 'conferenceRoomMessage',
    label: 'Conference Room Message',
  },
};